define('views/modules/calendar/animated-session/exercise/weight/weight-header',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    // Views
    'views/parts/menu/menu-context',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/weight/weight-header.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    // views
    VMenuContext,
    // templates
    TWeightExerciseHeader
) {

    var VWeightExerciseHeader = Backbone.Epoxy.View.extend({
        tagName: "thead",
        template: TWeightExerciseHeader,

        bindingFilters: {
            translate: function(text) {
                if (_.isNull(text)) return "";
                return i18n.t(text.charAt(0).toUpperCase() + text.slice(1));
            }
        },

        events: {
            "click .reps-button": "onRepsClick",
        },

        regions: {
            menu: ".menu-options"
        },

        /**
         * Provide a "first" option to add the week and sets columns.
         */
        initialize: function(opt) {
            this.options = opt || {};
            this.view = {};

        },
        render: function() {
            this.$el.empty()
                .append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();

            this.applyBindings();

            return this;
        },

        ////////////
        // events //
        ////////////
        onRepsClick: function(e) {
            var view = this.view,
                menu = view.menu;
            if (!menu) {

                menu = view.menu = new VMenuContext({
                    context: this,
                    onClick: this.onActionClick,
                    arrow: "bottom",
                    collection: new Backbone.Collection([
                        { caption: 'Repetitions', value: "reps", },
                        { caption: 'Minutes', value: "mins", },
                        { caption: 'Seconds', value: "secs", },
                        { caption: 'Kilometers', value: "km" },
                        { caption: 'Miles', value: "miles" },
                        { caption: 'Meters', value: "meters" },
                    ]),
                });
                this.assign(menu, this.zone.$menu);

            }
            menu.toggle();

        },

        onActionClick: function(e, item) {
            e.preventDefault();
            this.model.set({ repsType: item.get('value') });
        },
    });

    return VWeightExerciseHeader;

});

